// extracted by mini-css-extract-plugin
module.exports = {"prices":"PricesView_prices__AOMOj"};